import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import {
  ShoppingCart, Plus, Search, Factory, Truck, HardHat,
  ChevronRight,
} from 'lucide-react';
import {
  commandes, etapesCommande,
  formatDate, formatMontant,
} from '../data/mockData';

const etapeIcon = {
  creation: ShoppingCart,
  depart_usine: Factory,
  reception_bl: Truck,
  installation: HardHat,
};

const Commandes = () => {
  const navigate = useNavigate();
  const [search, setSearch] = useState('');
  const [etapeFilter, setEtapeFilter] = useState('tous');

  const filtered = commandes
    .filter((c) => etapeFilter === 'tous' || c.etape === etapeFilter)
    .filter((c) =>
      c.id.toLowerCase().includes(search.toLowerCase()) ||
      c.chantier.toLowerCase().includes(search.toLowerCase()) ||
      c.fournisseurNom.toLowerCase().includes(search.toLowerCase())
    );

  return (
    <div className="page-container">
      <div className="page-header">
        <div>
          <h1 className="page-title">Commandes fournisseurs</h1>
          <p className="page-subtitle">Cycle complet : Creation - Depart usine - Reception BL - Installation chantier</p>
        </div>
        <button className="btn-primary">
          <Plus size={16} /> Nouvelle commande
        </button>
      </div>

      <div className="toolbar">
        <div className="search-input grow">
          <Search size={16} />
          <input
            placeholder="Rechercher une commande, un chantier ou un fournisseur"
            value={search}
            onChange={(e) => setSearch(e.target.value)}
          />
        </div>
        <div className="seg-control">
          <button className={etapeFilter === 'tous' ? 'active' : ''} onClick={() => setEtapeFilter('tous')}>
            Toutes
          </button>
          {etapesCommande.map((e) => (
            <button
              key={e.id}
              className={etapeFilter === e.id ? 'active' : ''}
              onClick={() => setEtapeFilter(e.id)}
            >
              {e.label}
            </button>
          ))}
        </div>
      </div>

      <div className="card">
        <div className="card-body">
          <table className="data-table clickable">
            <thead>
              <tr>
                <th>Commande</th>
                <th>Date</th>
                <th>Fournisseur</th>
                <th>Chantier</th>
                <th>BL</th>
                <th>Etape</th>
                <th style={{ textAlign: 'right' }}>Montant HT</th>
                <th></th>
              </tr>
            </thead>
            <tbody>
              {filtered.map((cmd) => {
                const Icon = etapeIcon[cmd.etape];
                const etapeLib = etapesCommande.find((e) => e.id === cmd.etape)?.label;
                return (
                  <tr
                    key={cmd.id}
                    className="hoverable clickable"
                    onClick={() => navigate(`/commandes/${cmd.id}`)}
                  >
                    <td>
                      <div className="cell-strong">
                        <ShoppingCart size={16} className="cell-icon" />
                        <div>
                          <p className="mono">{cmd.id}</p>
                          <span className="meta-line">{cmd.lignes.length} ligne(s)</span>
                        </div>
                      </div>
                    </td>
                    <td>{formatDate(cmd.date)}</td>
                    <td>{cmd.fournisseurNom}</td>
                    <td>{cmd.chantier}</td>
                    <td>
                      {cmd.bl ? (
                        <span className="mono">{cmd.bl.numero}</span>
                      ) : (
                        <span className="meta-line">-</span>
                      )}
                    </td>
                    <td>
                      <span className={`badge badge-${cmd.etape === 'installation' ? 'ok' : 'info'}`}>
                        <Icon size={12} /> {etapeLib}
                      </span>
                    </td>
                    <td style={{ textAlign: 'right' }}>
                      <strong>{formatMontant(cmd.montantHT)}</strong>
                    </td>
                    <td style={{ width: 28 }}>
                      <ChevronRight size={16} className="arrow-muted" />
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </table>

          {filtered.length === 0 && (
            <div className="empty-state">
              <ShoppingCart size={28} />
              <p>Aucune commande ne correspond a votre recherche.</p>
            </div>
          )}
        </div>
      </div>

      <p className="meta-line" style={{ marginTop: '1rem' }}>
        {filtered.length} commande(s) affichee(s). Cliquez sur une ligne pour consulter le cycle complet.
      </p>
    </div>
  );
};

export default Commandes;
